/**
 * Logger utility for consistent logging across the application
 * In production, only errors and warnings are logged
 * Debug logs are only shown in development
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug logging - only in development
   * Use for debugging during development
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Info logging - only in development
   * Use for informational messages
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * General logging - only in development
   * Alias for debug
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Warning logging - always logged
   * Use for recoverable errors or important warnings
   */
  warn: (...args: any[]) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Error logging - always logged
   * Use for errors that should be tracked
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
    // TODO: Send to error monitoring service (Sentry, LogRocket, etc.)
  },
};

export default logger;
